import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiInstance } from '../services/service-trips-api/service-trips-api';
import { toAgreementPartnerId } from '../services/service-trips-api/types';
import type { AgreementPartnerDto } from '../services/service-trips-api/types/agreement-partner';
import { QueryKeys } from './types';

export const useAgreementPartnersQuery = () =>
  useQuery<AgreementPartnerDto[]>({
    queryKey: [QueryKeys.AgreementPartners],
    queryFn: apiInstance.getAgreementPartners,
    throwOnError: true,
  });

export const useCreateAgreementPartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { name: string }) =>
      apiInstance.createAgreementPartner(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AgreementPartners] });
    },
  });
};

export const useUpdateAgreementPartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, name }: { id: number; name: string }) =>
      apiInstance.updateAgreementPartner(toAgreementPartnerId(id), { name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AgreementPartners] });
    },
  });
};

export const useDeleteAgreementPartnerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiInstance.deleteAgreementPartner(toAgreementPartnerId(id)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AgreementPartners] });
    },
  });
};
